// Generated from backend/utils/eventMentionParts.ts; do not edit.
type Row = Record<string, any>;
export type EventMentionPart = { id: string; label: string; aliases: string[]; profilePartId: string; sortOrder: number };

const labelOf = (value: unknown): string => String(value ?? '').replace(/^[@＠]+/, '').replace(/\s+/g, ' ').trim().slice(0, 80);
const firstLabel = (...values: unknown[]): string => values.map(labelOf).find(Boolean) || '';
const UNASSIGNED = 'パート未設定';

export function getEventMentionArtists(snapshot?: Row | null): Row[] {
  return ['artists', 'manual_chat_artists', 'concierge_planners'].flatMap(key =>
    Array.isArray(snapshot?.[key]) ? snapshot[key] : []);
}

// Event casting assignments take precedence over the artist's registered instruments.
// Each target is an identity, never a count of matching display-label aliases.
export function getEventMentionParts(artist: Row = {}): EventMentionPart[] {
  const row = { ...artist.payload, ...artist };
  const assignments = row.event_part_assignments ?? row.eventPartAssignments ?? [];
  const targets = new Map<string, EventMentionPart>();
  for (const assignment of Array.isArray(assignments) ? assignments : []) {
    if (assignment?.has_assignment === false || assignment?.hasAssignment === false) continue;
    const label = firstLabel(assignment?.part_label, assignment?.partLabel, assignment?.part, assignment?.label);
    if (!label || label === UNASSIGNED) continue;
    const id = `event-part:${label}`;
    const order = Number(assignment?.part_sort_order ?? assignment?.partSortOrder ?? 9999);
    targets.set(id, { id, label, aliases: [label], profilePartId: '', sortOrder: Number.isFinite(order) ? order : 9999 });
  }
  if (targets.size) return [...targets.values()];

  const label = firstLabel(row.artist_part_label, row.main_part_label, row.part_label,
    row.artist_part_short_name, row.main_part_short_name, row.part_short_name,
    row.partLabel, row.mainPartLabel, row.eventPartLabel);
  if (!label || label === UNASSIGNED) {
    return [{ id: '__unassigned_part__', label: UNASSIGNED, aliases: [], profilePartId: '', sortOrder: 10000 }];
  }
  const rawParts = row.artist_parts ?? row.parts ?? [];
  const parts = Array.isArray(rawParts) ? rawParts : String(rawParts).replace(/[{}[\]]/g, '').split(',');
  const primaryId = String(parts[0] ?? '').trim();
  return [{ id: `event-part:${label}`, label,
    aliases: [...new Set([label, labelOf(row.artist_part_short_name), labelOf(row.main_part_short_name), labelOf(row.part_short_name)].filter(Boolean))],
    profilePartId: /^\d+$/.test(primaryId) ? primaryId : '', sortOrder: 9999 }];
}

export function matchesEventMentionPart(mention: Row, artist: Row): boolean {
  const id = String(mention.targetId ?? mention.target_id ?? '').trim();
  const label = labelOf(mention.label);
  return getEventMentionParts(artist).some(part => {
    if (id.startsWith('event-part:')) return id === part.id && label === part.label;
    if (id === '__unassigned_part__' || label === UNASSIGNED) return part.id === '__unassigned_part__';
    return (Boolean(part.profilePartId) && id === part.profilePartId) || part.aliases.includes(label);
  });
}
